import React, { PureComponent, Fragment } from 'react';
import Icon from '~/core/scripts/components/Icon';

function getIcon(status) {
  if (status === 'Einzelwolf') {
    return 'einzeltier';
  }

  return status.toLowerCase();
}

function getWelpenLabel(area) {
  if (area.Welpen === '') {
    return 'Welpenanzahl unbekannt';
  }

  const welpenLabel = +area.Welpen === 1 ? 'Welpe' : 'Welpen';
  return `${area.Welpen} ${welpenLabel}`;
}

function getAreaLabel(isExtraMarker, firstYear) {
  if (isExtraMarker) {
    return <em>neues Wolfsterritorium in 2018</em>;
  }

  return `Wolfsterritorium seit ${firstYear}`;
}

class AreaDisplay extends PureComponent {
  render() {
    let { area, firstYear = false, currentYear = false, isExtraMarker } = this.props;

    return (
      <Fragment>
        <div className="tooltip-header">
          <div className="tooltip-state">{area.Bundesland}</div>
          <div className="tooltip-title">{area.Territorium}</div>
          {(firstYear || isExtraMarker) && <div className="tooltip-subtitle">{getAreaLabel(isExtraMarker, firstYear)}</div>}
        </div>
        <div className="tooltip-body">
          {currentYear && (
            <div className="tooltip-currentyear">{currentYear + 1}</div>
          )}
            <div className="tooltip-icon">
              <Icon type={getIcon(area.Status)} />
            </div>
            <div className="tooltip-label">
              <div>{area.Status}</div>
              {area.Status === 'Rudel' && <div className="light">{getWelpenLabel(area)}</div>}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AreaDisplay;
